// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".utility-bar__widget[data-v-39e34b48]{margin:0}", ""]);
// Exports
module.exports = exports;
